import { render, staticRenderFns } from "./MaterialCompare.vue?vue&type=template&id=617ef9b3&scoped=true"
import script from "./MaterialCompare.vue?vue&type=script&lang=js"
export * from "./MaterialCompare.vue?vue&type=script&lang=js"
import style0 from "./MaterialCompare.vue?vue&type=style&index=0&id=617ef9b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617ef9b3",
  null
  
)

export default component.exports